<section class="flex flex-col items-center gap-y-8 py-10">
  <div class="flex max-w-2xl flex-col items-center gap-y-3 text-center">
    <div
      aria-hidden="true"
      class="size-14 rounded-2xl bg-gradient-to-br from-brand-studio-dark to-brand-studio shadow-lg"
      style="transform: skewX(-5.7deg)"
    ></div>

    <p class="m-0 mt-2 text-xs font-bold tracking-[0.08em] text-brand-studio uppercase">
      Spark Ads · TikTok
    </p>
    <h1 class="m-0 text-3xl font-bold text-primary">No campaigns yet. Let’s fix that.</h1>
    <p class="m-0 max-w-xl text-sm text-secondary">
      @if (clearedPostCount(); as count) {
        Your creators have {{ count }} cleared {{ count === 1 ? 'post' : 'posts' }} ready. Put
        budget behind the ones that are working — from their handle, with their likes and comments
        intact.
      } @else {
        Put budget behind the creator posts that are working — from their handle, with their likes
        and comments intact.
      }
    </p>

    <div class="mt-2 flex flex-col gap-3 sm:flex-row">
      <button type="button" (click)="onCreateCampaign()" class="primary-button">
        Create your first campaign
      </button>
      <button type="button" (click)="onBrowseVideos()" class="secondary-button">
        Browse creator videos
      </button>
    </div>
  </div>

  <ol class="m-0 grid w-full max-w-4xl list-none grid-cols-1 gap-4 p-0 sm:grid-cols-3">
    @for (step of steps; track step.number) {
      <li class="flex flex-col gap-y-2 rounded-xl border border-border bg-card p-5 shadow-sm">
        <p
          class="m-0 flex size-7 items-center justify-center rounded-full bg-brand-studio text-sm font-bold text-white"
          aria-hidden="true"
        >
          {{ step.number }}
        </p>
        <h2 class="m-0 text-base font-semibold text-primary">{{ step.title }}</h2>
        <p class="m-0 text-sm text-secondary">{{ step.body }}</p>
      </li>
    }
  </ol>
</section>
